function initVideo(){

  if(!$('#init-video').length) return false;

	var ww = $(window).width();	
	var videoConfig = JSON.parse($("#init-video").html());
	if (ww > 800){
		var video = $('<video id="bgvid" muted autoplay loop playsinline></video>', {
	    poster: videoConfig.poster
		});
		
		for (src in videoConfig.srcset){
			if (videoConfig.srcset.hasOwnProperty(src)){
				var source = $('<source></source>', {	    
					src: videoConfig.srcset[src],
					type:"video/"+src
				});
				video.append(source);
			}
		}	
		video.insertAfter($("#init-video"));
	}
}

function iframeInit(){
  $('iframe').on('load', function(e) {
    e.preventDefault();
    $(this).parents('.video-container')
  });
}

//init google map
function initialize() {
  var imc= {lat: 34.3670178, lng: -89.5330891};
  var map;
  var mapOptions = {
      zoom:17,
      center: imc,
      scrollwheel: false
      // styles:[
      //       {
      //       featureType: "all",
      //       stylers: [
      //         { hue: "#006fba" },
      //         { saturation: -100 }
      //       ]
      //     },{
      //       featureType: "road",
      //       elementType: "geometry",
      //       stylers: [
      //         { hue: "#006fba" },
      //         { saturation: 200 }
      //       ]
      //     },{
      //       featureType: "poi.business",
      //       elementType: "labels",
      //       stylers: [
      //         { visibility: "off" }
      //       ]
      //     }
      //   ]
  };

  // var icon = {
  //  url: location.protocol + '//' + location.hostname + '/wp-content/themes/mms/dist/images/pin.png',
  //  scaledSize: new google.maps.Size(20, 32),
  // };

  map = new google.maps.Map(document.getElementById("map"), mapOptions);       
  var marker = new google.maps.Marker({
    position: imc,
    map: map,
    //icon: icon,
  });                
    
}

$(document).ready(function($) {

	initVideo();
		
  $('.menu-toggle').on('click', function(e){
    e.preventDefault();
    $(this).toggleClass('closer');
    $('body').toggleClass('menu-open lock');
  });

  $(".expander-head").on('click', function(e){
    e.preventDefault();
    $(this).siblings('.expander-content').slideToggle();
    $(this).find('.course-title').toggleClass('active');
    $(this).find('i').toggleClass('open');
  });

  $(".search-trigger").on('click', function(e){
    e.preventDefault();
    $(".search-overlay").addClass('active');
    setTimeout(function(){
			$('.search-overlay form input[type="text"]').click();	    
    }, 500);

	});
	
	$(".search-closer, .search-overlay").on('click', function(e){    
    if($(e.target).is(".search-closer") || $(e.target).parents(".search-closer").length){
	    e.preventDefault();
	    $(".search-overlay").removeClass('active');

    }

    else if (!($(e.target).is(".search-overlay form") || $(e.target).parents("form").length)){
      e.preventDefault();
			$(".search-overlay").removeClass('active');			
		}
		else{
			return true;
		}
		
	});

  if ($('#map').length){
    // Asynchronously Load the map API
    var script = document.createElement('script');
    script.src = "//maps.googleapis.com/maps/api/js?callback=initialize&key=AIzaSyDDBDke3q2XzpVG9q63uxcxlGKqc371YB8";
    document.body.appendChild(script);
  }

  if ($('.test-slider').length){
    $('.test-slider').slick({
        arrows: true,
        dots: false,
        speed: 500,
        fade: true,
        infinite: true,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: false,
        // adaptiveHeight: true,
    });
  }


	$('iframe[src*="vimeo"], iframe[src*="youtube"]').parent().fitVids();

    $('.video-overlay-trigger').on('click', function(e){
        e.preventDefault();
        iframeInit();
        $('.video-overlay').addClass('active');
        $('body').addClass('scroll-lock');
        var video = $(this).siblings(".video-overlay").find("iframe");
        var src = video.attr("src")+"?autoplay=1";
        video.attr("src", src);
        setTimeout(function(){
          $('.video-container').toggleClass('loaded');
        }, 300);
        
    });
    $('.video-closer').on('click', function(e){
        e.preventDefault();
        $('.video-overlay').removeClass('active');
        $('body').removeClass('scroll-lock');
        var video = $(this).siblings().find("iframe");
        var src = video.attr("src").split('?')[0];
        console.log(src);
        video.attr("src", src);
    });
    $('.video-overlay').on('click', function(e){
        e.preventDefault();
       if($(this).hasClass('active')){
           $(this).removeClass('active');
           $('body').removeClass('scroll-lock');
           var video = $(this).find("iframe");
           var src = video.attr("src").split('?')[0];
           console.log(src);
           video.attr("src", src);
       }
    });
	
	$(document).on('touchmove scroll mousewheel DOMMouseScroll', function(e){
	    
	  if (!$('body').hasClass('lock')){
	    return; //Allow scrolling while menu is closed
	  }
	  
	  if( $(e.target).is($('nav.nav-primary')) || $.contains($('nav.nav-primary'), e.target) || $(e.target).is($('.overlay')) || $(e.target).parents('.overlay').length>0 ){
	    return; //Allow scolling if mouse is in nav-primary
	  }
	  
	  e.preventDefault();
	  return false;
	});


  $('.stat-slider').slick({
    infinite: true,
    slidesToShow: 5,
    autoplay:false,
    infinite: true,
    dots: false,
    responsive: [
      {
        breakpoint:1000,
        settings:{
          slidesToShow:3,
          slidesToScroll:1,
          autoplay:true,
          autoplaySpeed:2000,
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay:true,
          autoplaySpeed:2000,
          dots:true
        }
      },
    ]
  });
  
});


